import React from 'react'
import type { Icon } from 'shared/utils'

const Order = (props: Icon) => {
    const { color = 'white', size = 24, className = 'order' } = props
    return (
        <svg className={className} width={size} height={size} fill={color}>
            <path
                fillRule="evenodd"
                d="M8.97 8.25h-.614c-.361-.225-.781-.605-1.186-.607-.411-.002-.806.38-1.17.608V20.3c0 .698.53 1.245 1.183 1.245h9.56c.593 0 1.075-.497 1.075-1.11V8.251h-.617l-.108-.064c-.306-.181-.661-.54-1.002-.545-.397-.005-.78.377-1.126.609h-.791c-.309-.212-.676-.593-1.03-.607-.398-.016-.783.358-1.131.59l-.659.017c-.36-.24-.788-.629-1.202-.629-.37 0-.727.364-1.061.558l-.122.07zm6.12-1.629a.682.682 0 0 1-.681-.681 2.351 2.351 0 0 0-2.349-2.35 2.351 2.351 0 0 0-2.348 2.35.682.682 0 0 1-1.363 0 3.716 3.716 0 0 1 3.712-3.712 3.716 3.716 0 0 1 3.711 3.712.682.682 0 0 1-.681.681"
            />
        </svg>
    )
}

export { Order }
